/**
 * GENERADO por tools/generar-catalogo-planes.js — NO EDITAR A MANO.
 *
 * Es el MISMO catálogo que consume la grilla de la landing, en ESM para /contratar: los
 * dos salen de `functions/config/planLimits.js` y de `functions/config/pricingMap.js`, así
 * que no pueden contradecirse. El test `catalogoDePlanes.parity.jest.test.js` regenera
 * este fichero en memoria y se pone rojo si difiere.
 *
 * `priceId` viene de `pricingMap`: antes estaba copiado a mano en Contratar.js.
 */
export const catalogoDePlanes = {
  "_": "GENERADO por tools/generar-catalogo-planes.js desde functions/config/planLimits.js. NO editar a mano: el test de paridad y el pre-commit se ponen rojos.",
  "moneda": "USD",
  "addonDesde": 19,
  "planes": [
    {
      "id": "starter",
      "nombre": "Starter",
      "recomendado": false,
      "precio": 147,
      "priceId": "price_1TpD8YAdK4QV10704Gy9lav0"
    },
    {
      "id": "pro",
      "nombre": "Pro",
      "recomendado": true,
      "precio": 297,
      "priceId": "price_1TpD9qAdK4QV1070sYogAAUt"
    }
  ],
  "filas": [
    {
      "clave": "asistentes",
      "i18n": "pricing.row.asistentes",
      "sub": "pricing.sub.incluidos",
      "valores": {
        "starter": {
          "t": "num",
          "n": 1,
          "max": 2
        },
        "pro": {
          "t": "num",
          "n": 3,
          "max": 5
        }
      }
    },
    {
      "clave": "numeros",
      "i18n": "pricing.row.numeros",
      "sub": "pricing.sub.incluidos",
      "valores": {
        "starter": {
          "t": "num",
          "n": 1,
          "ampliable": false
        },
        "pro": {
          "t": "num",
          "n": 3,
          "max": 5
        }
      }
    },
    {
      "clave": "usuarios",
      "i18n": "pricing.row.usuarios",
      "sub": "pricing.sub.incluidos",
      "valores": {
        "starter": {
          "t": "num",
          "n": 2,
          "ampliable": false
        },
        "pro": {
          "t": "num",
          "n": 5,
          "ilimitado": true
        }
      }
    },
    {
      "clave": "respuestas",
      "i18n": "pricing.row.respuestas",
      "valores": {
        "starter": {
          "t": "num",
          "n": 24000
        },
        "pro": {
          "t": "num",
          "n": 72000
        }
      }
    },
    {
      "clave": "cuentas",
      "i18n": "pricing.row.cuentas",
      "valores": {
        "starter": {
          "t": "num",
          "n": 1
        },
        "pro": {
          "t": "num",
          "n": 3
        }
      }
    },
    {
      "clave": "canales",
      "i18n": "pricing.row.canales",
      "fusionada": true,
      "valores": {
        "starter": {
          "t": "i18n",
          "k": "pricing.val.canales"
        },
        "pro": {
          "t": "i18n",
          "k": "pricing.val.canales"
        }
      }
    },
    {
      "clave": "agendas",
      "i18n": "pricing.row.agendas",
      "sub": "pricing.sub.incluidas",
      "valores": {
        "starter": {
          "t": "num",
          "n": 2,
          "ilimitado": true
        },
        "pro": {
          "t": "num",
          "n": 5,
          "ilimitado": true
        }
      }
    },
    {
      "clave": "integraciones",
      "i18n": "pricing.row.integraciones",
      "valores": {
        "starter": {
          "t": "i18n",
          "k": "pricing.val.integracion_una"
        },
        "pro": {
          "t": "i18n",
          "k": "pricing.val.integracion_ambas"
        }
      }
    },
    {
      "clave": "documentos",
      "i18n": "pricing.row.documentos",
      "valores": {
        "starter": {
          "t": "mb",
          "mb": 250
        },
        "pro": {
          "t": "mb",
          "mb": 1024
        }
      }
    }
  ],
  "detalle": [
    {
      "clave": "almacenamiento",
      "i18n": "pricing.det.almacenamiento",
      "valores": {
        "starter": {
          "t": "mb",
          "mb": 250
        },
        "pro": {
          "t": "mb",
          "mb": 1024
        }
      }
    },
    {
      "clave": "procesamiento",
      "i18n": "pricing.det.procesamiento",
      "valores": {
        "starter": {
          "t": "mb",
          "mb": 500
        },
        "pro": {
          "t": "mb",
          "mb": 2048
        }
      }
    },
    {
      "clave": "pausa",
      "i18n": "pricing.det.pausa",
      "valores": {
        "starter": {
          "t": "nota"
        },
        "pro": {
          "t": "nota"
        }
      }
    },
    {
      "clave": "playbooks",
      "i18n": "pricing.det.playbooks",
      "valores": {
        "starter": {
          "t": "si"
        },
        "pro": {
          "t": "si"
        }
      }
    },
    {
      "clave": "inbox",
      "i18n": "pricing.det.inbox",
      "valores": {
        "starter": {
          "t": "si"
        },
        "pro": {
          "t": "si"
        }
      }
    },
    {
      "clave": "audio",
      "i18n": "pricing.det.audio",
      "valores": {
        "starter": {
          "t": "si"
        },
        "pro": {
          "t": "si"
        }
      }
    },
    {
      "clave": "vision",
      "i18n": "pricing.det.vision",
      "valores": {
        "starter": {
          "t": "si"
        },
        "pro": {
          "t": "si"
        }
      }
    }
  ]
};

/** Price IDs de Stripe por plan, derivados de functions/config/pricingMap.js. */
export const STRIPE_PRICE_IDS = Object.freeze({
  "starter": "price_1TpD8YAdK4QV10704Gy9lav0",
  "pro": "price_1TpD9qAdK4QV1070sYogAAUt"
});

export default catalogoDePlanes;
